/* 🤖 this file was generated by svg-to-ts */
export const mgcIconRightSmallCuteFi: {
  name: 'right-small-cute-fi';
  data: string;
} = {
  name: 'right-small-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.58 7.736c-.417.132-.715.386-.927.79-.102.195-.112.252-.113.634 0 .369.013.447.104.64.129.274.325.476.751.777.183.129.417.305.519.391.352.298 1.006.972 1.006 1.037 0 .103-.993 1.038-1.447 1.361-.509.363-.695.551-.829.834-.09.191-.104.272-.104.62 0 .35.013.429.106.627.314.669 1.07 1.019 1.762.818.629-.183 2.129-1.435 2.956-2.466.676-.844.846-1.205.846-1.799s-.17-.955-.846-1.799c-.813-1.014-2.32-2.278-2.935-2.461-.244-.072-.628-.074-.849-.004"/></svg>`
};
